const gifImage=document.getElementsByClassName("gif-image");
const ytPlayButton=document.getElementsByClassName("youtube-video__player-iframe");
if(gifImage && gifImage[0]){
    gifImage[0].addEventListener('click', () => {
        if(ytPlayButton && ytPlayButton[0]){
            gifImage[0].classList.add("hide-gif");
            ytPlayButton[0].classList.add("show-gif");
            ytPlayButton[0].src=ytPlayButton[0].src+"&autoplay=1";
            ytPlayButton[0].allow="autoplay";
        }
      });
  }

const gifImage1=document.getElementsByClassName("gif-image1");
const ytPlayButton1=document.getElementsByClassName("youtube-video__player-iframe1");
if(gifImage1 && gifImage1[0]){
    gifImage1[0].addEventListener('click', () => {
        if(ytPlayButton1 && ytPlayButton1[0]){
            gifImage1[0].classList.add("hide-gif");
            ytPlayButton1[0].classList.add("show-gif");
            ytPlayButton1[0].src=ytPlayButton1[0].src+"&autoplay=1";
            ytPlayButton1[0].allow="autoplay";
        }
      });
  }